import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api'
import { useWindowSize } from '@vueuse/core'

// TODO we should rename this component to something more general because it is used in places that aren't "Profile Completion"

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileCompletionModal',
  setup(__props) {

const { width } = useWindowSize()
const isMobile = computed(() => width.value < 640)

return { __sfc: true,width, isMobile }
}

})